const route = {
  path: '/',
  name: 'sf',
  component: () => import('@/views/sf'),
  redirect: '/sf/home',
  meta: { routeName: '顺丰快递' },
  children: [
    {
      path: '/sf/home',
      name: 'home',
      component: () => import('@/views/sf/home'),
      meta: { routeName: '顺丰快递' }
    },
    {
      path: '/sf/myinfo',
      name: 'myinfo',
      component: () => import('@/views/sf/myinfo'),
      meta: { routeName: '个人信息' }
    },
    {
      path: '/sf/my',
      name: 'my',
      component: () => import('@/views/sf/my'),
      meta: { routeName: '个人中心' }
    },
    {
      path: '/sf/addexpress',
      name: 'addexpress',
      component: () => import('@/views/sf/addexpress'),
      meta: { routeName: '寄快递', keepAlive: true }
    },
    {
      path: '/sf/addresslist',
      name: 'addresslist',
      component: () => import('@/views/sf/addresslist'),
      meta: { routeName: '地址管理' }
    },
    {
      path: '/sf/expressdetail',
      name: 'expressdetail',
      component: () => import('@/views/sf/expressdetail'),
      meta: { routeName: '快递详情' }
    },
    {
      path: '/sf/addaddress',
      name: 'addaddress',
      component: () => import('@/views/sf/addaddress'),
      meta: { routeName: '地址编辑' }
    },
    {
      path: '/sf/search',
      name: 'search',
      component: () => import('@/views/sf/search'),
      meta: { routeName: '查件', keepAlive: false }
    },
    {
      path: '/sf/waitpay',
      name: 'waitpay',
      component: () => import('@/views/sf/waitpay'),
      meta: { routeName: '待支付' }
    },
    {
      path: '/sf/coupons',
      name: 'coupons',
      component: () => import('@/views/sf/coupons'),
      meta: { routeName: '优惠券' }
    }
  ]
}
export default route
